// extracted by mini-css-extract-plugin
export default {"stepHeaderContainer":"steps-header_stepHeaderContainer__CKQ6D"};